import {
  ExpandableSection,
  PremiumBreakdown,
  PremiumSummary,
  smBumps,
} from '@wrisk/ui-components'
import React, { FC } from 'react'

import { Promotion } from '../../../domain'
import { QuotePremiums } from '../../../hooks/premiums'
import { tDefaults, TKeyBuilder } from '../../../infrastructure/internationalisation'
import { getSchemeHelpContentBaseUrl, useConfig } from '../../../state/configuration'
import { useProduct } from '../../product/ProductProvider'
import { IPT } from '../product'
import { useStandardAdjustedPremium } from './hooks'

export interface StandardAdjustedPremiumProps {
  currentPremiums: QuotePremiums
  previousPremiums?: QuotePremiums
  promotion?: Promotion
  expanded?: boolean
  tKey: TKeyBuilder
  onExpansionChange?: (isExpanded: boolean) => void
}

export const StandardAdjustedPremium: FC<StandardAdjustedPremiumProps> = ({
  currentPremiums,
  previousPremiums,
  promotion,
  expanded,
  tKey,
  onExpansionChange,
}) => {
  const {
    scheme: { schemeCode },
  } = useProduct()

  const contentBaseUrl = useConfig(getSchemeHelpContentBaseUrl(schemeCode))

  const {
    currentAmount,
    previousAmount,
    header,
    lineItems,
    additionalItems,
    promo,
    extraInfo,
    termTotal,
  } = useStandardAdjustedPremium({
    currentPremiums,
    previousPremiums,
    promotion,
    tKey,
  })

  const {
    breakdown: { fees },
  } = currentPremiums

  const iptKey = Object.keys(fees).length ? tDefaults('ipt.withExcludedFees') : undefined

  const showTermTotal = currentPremiums?.paymentSchedule === 'MONTHLY'

  const subheader = [showTermTotal && termTotal, promo].filter(Boolean).join('\n')

  const headerEl = (
    <PremiumSummary
      header={header}
      subheader={subheader}
      currentAmount={currentAmount}
      previousAmount={previousAmount}
    />
  )

  return (
    <ExpandableSection
      header={headerEl}
      open={expanded}
      reversed
      onChange={onExpansionChange}
    >
      <PremiumBreakdown
        extraInfo={extraInfo}
        mx={smBumps}
        lineItems={lineItems}
        additionalLineItems={additionalItems}
        ipt={<IPT amount={currentPremiums.totals.taxAmount} iptKey={iptKey} />}
        contentBaseUrl={contentBaseUrl}
      />
    </ExpandableSection>
  )
}
